import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';


export const StoreToPlantPopup = (props) => {
    const itemColdefs = [
        {
            field: "keyId",
            headerName: "Sr. No",
            minWidth: window.innerWidth * 0.04,
            flex: 0.4,
            filter: false,
            floatingFilter: false,
            valueGetter: (params) => params.node.rowIndex + 1,
        },
        {
            field: "itemName",
            headerName: "Item name",
            minWidth: window.innerWidth * 0.25,
            flex: 2.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "drawingNo",
            headerName: "drawingNo",
            minWidth: window.innerWidth * 0.11,
            flex: 1.1,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "stock",
            headerName: "Stock",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "quantity",
            headerName: "Qty",
            minWidth: window.innerWidth * 0.06,
            flex: 1,
            filter: true,
            floatingFilter: true,
            valueFormatter: (params) => {
                if (params.value == null || params.value === "") return "";
                const num = Number(params.value);
                return Number.isInteger(num) ? num : num.toFixed(2);
            },
        },
        {
            field: "remarks",
            headerName: "Remarks",
            minWidth: window.innerWidth * 0.1,
            flex: 1,
            filter: true,
            floatingFilter: true,
        },
        // {
        //     field: "Action",
        //     headerName: "Action",
        //     minWidth: window.innerWidth * 0.06,
        //     flex: 0.6,
        //     filter: false,
        //     floatingFilter: false,
        //     cellClass: "action-col !p-0 flex items-center justify-center",
        //     cellRenderer: (params) => (
        //         <button
        //             className='bg-red-100 text-red-500 hover:bg-red-500 hover:text-white w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
        //             onClick={() => props.deleteItem(params.data.keyId)}
        //         >
        //             <FontAwesomeIcon icon={faTrashCan} />
        //         </button>
        //     ),
        // }
    ];

    return (
        <ModalBasic
            id="stock-to-plant"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Transfer details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Transfer no</label>
                        <TextInput type='text'
                            id='transferNo' name='transferNo'
                            value={props.transferObject.transferNo}
                            handleChange={(event) => props.handleChange(event, 'transferNo', 'transfer')}
                            className={props.validState?.error?.transferNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.transferObject.date}
                            handleChange={(event) => props.handleChange(event, 'date', 'transfer')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>From</label>
                        <MultiSelectDropdown
                            drpIdentity="Select from"
                            options={props.transferObject.fromList}
                            value={props.transferObject.idFrom > 0 ? props.transferObject.fromList.find(x => x.value === props.transferObject.idFrom) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idFrom", "transfer")
                            }
                            className={props.validState?.error?.idFrom !== undefined ? "error" : ""}
                            isDisabled={props.itemRowData.length > 0 ? true : false}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select item</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.transferObject.itemList}
                            value={props.transferObject.idItem > 0 ? props.transferObject.itemList.find(x => x.value === props.transferObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem", "transfer")
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                            isDisabled={props.isDisabledSelectItem || props.itemRowData.length > 0 ? true : false}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.transferObject.itemName}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList2")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.transferObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo', 'transfer')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled={props.itemRowData.length > 0 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.transferObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity', 'transfer')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                            disabled={props.itemRowData.length > 0 ? true : false}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select location</label>
                        <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.transferObject.locationList}
                            value={props.transferObject.idLocation > 0 ? props.transferObject.locationList.find(x => x.value === props.transferObject.idLocation) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idLocation", "transfer")
                            }
                            className={props.validState?.error?.idLocation !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Reference no</label>
                        <TextInput type='text'
                            id='refNo' name='refNo'
                            value={props.transferObject.refNo}
                            handleChange={(event) => props.handleChange(event, 'refNo')}
                            className={props.validState?.error?.refNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Transfer to</label>
                        <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.transferObject.transferList}
                            value={props.transferObject.idTransfer > 0 ? props.transferObject.transferList.find(x => x.value === props.transferObject.idTransfer) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idTransfer", "transfer")
                            }
                            className={props.validState?.error?.idTransfer !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Ref. date</label>
                        <TextInput type='date'
                            id='refDate' name='refDate'
                            value={props.transferObject.refDate}
                            handleChange={(event) => props.handleChange(event, 'refDate')}
                            className={props.validState?.error?.refDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp !inline-flex !gap-[5px] mt-4'>
                        <TextInput type='CheckBox'
                            id='isByPass' name='isByPass'
                            value={props.transferObject.isByPass}
                            checked={props.transferObject.isByPass}
                            handleChange={(event) => props.handleChangeForCheckBox(event, 'isByPass')}
                            className="w-[15px] h-[15px]"
                        />
                        <label>: Is Bypass from Material Issue</label>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5 col-span-2'>
                        <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.calcRequiredQty()}>BOM For Qty</button>
                        <button className="save-btn btns  px-[20px] h-[40px]" onClick={() => props.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print()}>Print BOM</button>
                    </div>

                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select itemname"
                            options={props.itemObject.itemNameList}
                            value={props.itemObject.idItemName > 0 ? props.itemObject.itemNameList.find(x => x.value === props.itemObject.idItemName) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItemName", "itemObject")
                            }
                            className={props.validState?.error?.idItemName !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="Select itemname"
                            name="itemName"
                            value={props.itemObject.itemName}
                            handleOnClick={(event) => props.handleOnClick(event, "selectItemList")}
                            disabled={true}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo', 'itemObject')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Stock</label>
                        <TextInput type='number'
                            id='stock' name='stock'
                            value={props.itemObject.stock}
                            handleChange={(event) => props.handleChange(event, 'stock', 'itemObject')}
                            className={props.validState?.error?.stock !== undefined ? "error" : ""}
                            disabled={true}
                        //disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity', 'itemObject')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks', 'itemObject')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {/* <button className="save-btn btns" onClick={() => props.submit()}>Insert</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Delete</button> */}
                        {props.itemObject.keyId > 0 ?
                            <>
                                <button className="save-btn btns py-[10px] px-[20px] h-[40px]"
                                    disabled={props.isInsertButtonLoading}
                                    onClick={() => props.insert("Update")}>Update</button>
                                <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.deleteItem(props.itemObject.keyId)}>Delete</button>
                            </>
                            :
                            <button
                                disabled={props.isInsertButtonLoading}
                                className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                    </div>
                </div>
                <div className="process-table h-[40vh] mt-2.5">
                    <span className="text-blue text-[16px] font-semibold">Transfer item details</span>
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onRowDoubleClicked={props.handleCellClickItemList}
                        //onGridReady={props.onGridReady}
                        //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                        //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-total flex items-end justify-between mt-[35px]'>
                    <div className='btn-grp flex gap-2.5'>
                        {
                            props.isSubmitButtonLoading ?
                                <button className="update-btn btns !cursor-not-allowed  h-[33px]">
                                    <div className="w-5 h-5 border-4 border-dashed rounded-full animate-spin border-white mx-auto"></div>
                                </button>
                                :
                                <button className="update-btn btns" onClick={() => props.submit()}>Save</button>

                        }
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                        {/* <button className="edit-btn btns">Print</button>
                        <button className="save-btn btns">Preview</button> */}
                    </div>
                </div>
            </div>

        </ModalBasic>
    )
}